import React, {Component} from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import './cart.scss';
import { line } from '../Svg/icons-cart';
import PDFViewer from 'mgr-pdf-viewer-react';
import CartButton from './cartButton';
import * as Icon from '../Svg';
import Throbber from '../../components/Throbber'
import IconPrev from '../Svg/icon-arrow-back'
import IconNext from '../Svg/icon-arrow-next'
import AppConfig from '../../const/config';

const previousPageBtn = ({ handlePrevClick, page, pages }) => {
    const activity = page === pages;
    
    if (!activity) {
        return null
    }
    
    return (
        <div className="pw_previousPageBtn" onClick={handlePrevClick}>
            <button>
                <IconPrev/>
            </button>
        </div>
    )
}

const nextPageBtn = ({ handleNextClick, page, pages }) => {
    const activity = page !== pages;
    
    if (!activity) {
        return null
    }
    
    return (
        <div className="pw_nextPageBtn" onClick={handleNextClick}>
            <button>
                <IconNext/>
            </button>
        </div>
    )
}

class Cart extends Component {
    state = {
        display: [ 'flex', 'none', 'none' ],
        class:   [],
        videoHasLoaded: false,
    };

    componentDidMount() {
        if (this.productVideoEl) {
            this.setState({videoHasLoaded: true})
        }
    }

    switchSection = (index) => {
        const display = [ 'none', 'none', 'none' ];
        display[ index ] = 'flex';
        this.setState({display});
    };

    videoClick = (e) => e.target.paused ? e.target.play() : e.target.pause();

    dlClick = (e) => {
        let a = document.createElement('a');
        a.href = process.env.PUBLIC_URL + '/pdf/' + this.props.cart.photo + '.pdf';
        a.download = this.props.cart.photo + '.pdf';
        a.click();
    };

    isSectionActive = (index) => {
        return this.state.display[ index ] !== 'none';
    }

    render() {
        const { locale } = AppConfig;
        const { videoHasLoaded } = this.state;
        const { photo, name, desc, html, pdf, video } = this.props.cart;
        
        if (!photo) {
            return null;
        }

        return (
            <div className = 'cart-wrap'>
                <div className = 'entity-modal'>
                    <div className = 'cart-content'>
                        <h2 className = 'cart-title'>{name}</h2>

                        <div style = {{marginLeft: '-10px'}}>{line}</div>

                        <div className = 'cart-content'>
                            <div
                                className = 'cart-video'
                                style = {{display: this.state.display[ 0 ]}}>
                                { photo !== 'nocontent' && (
                                    <TransitionGroup>
                                        {!videoHasLoaded && (
                                            <CSSTransition timeout={500} classNames="fade">
                                                <Throbber />
                                            </CSSTransition>
                                        )}

                                        <video
                                            autoPlay
                                            loop = { 'loop' }
                                            src = { process.env.PUBLIC_URL + '/video/catalog/' + photo + '.webm' }
                                            style = {{maxHeight: '800px'}}
                                            onClick = { this.videoClick }
                                            ref={(productVideoEl) => this.productVideoEl = productVideoEl}
                                        />
                                    </TransitionGroup>
                                )}
                            </div>

                            { false ? (
                                <div
                                    className = 'cart-text'
                                    style = {{display: this.state.display[ 1 ]}}>
                                    <div style = {{margin: '50px 0 40px 0', fontSize: '34px'}}>Назначение</div>
                                    <span>{desc}</span>
                                </div>
                            ) : (
                                <div
                                    className = 'cart-text'
                                    dangerouslySetInnerHTML = {{ __html: html }}
                                    style = {{display: this.state.display[ 1 ]}}>
                                </div>
                            )}

                            <div
                                className = 'cart-pdf'
                                style = {{display: this.state.display[ 2 ]}}>
                                { photo !== 'nocontent' && pdf !== false && typeof pdf !== 'undefined' ? (
                                    <PDFViewer
                                        css = 'pdf-wrap'
                                        document = {{url: `/pdf/${photo}.pdf` }}
                                        loader = { <p style = {{color: '#fff', textShadow: 'none', fontWeight: 'bold'}}>Идет загрузка...</p> }
                                        navigation = {{
                                            css: {
                                                previousPageBtn: 'pw_previousPageBtn',
                                                nextPageBtn:     'pw_nextPageBtn',
                                                pages:           'pw_pages',
                                                wrapper:         'pw_wrapper',
                                            },
                                            elements: {
                                                previousPageBtn,
                                                nextPageBtn
                                            }
                                        }}
                                        scale = { 1.332 }
                                    />
                                ) : (
                                    <p style={{ fontWeight: 'bold' }}>Отсутствует PDF-файл</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className = 'cart-navi'>
                        <div>
                            <CartButton
                                active = { this.isSectionActive(0) }
                                click = { this.switchSection.bind(this, 0) }
                            >
                                <Icon.Rotation/>
                            </CartButton>

                            <CartButton
                                active = { this.isSectionActive(1) }
                                click = { this.switchSection.bind(this, 1) }
                            >
                                <Icon.Information/>
                            </CartButton>
    
                            { locale !== 'en' && (photo !== 'nocontent' && pdf !== false && typeof pdf !== 'undefined') &&  (
                                <>
                                    <CartButton
                                        active = { this.isSectionActive(2) }
                                        click = { this.switchSection.bind(this, 2) }
                                    >
                                        <Icon.PdfView/>
                                    </CartButton>
    
                                    <CartButton
                                        click = { this.dlClick }
                                    >
                                        <Icon.PdfDownload/>
                                    </CartButton>
                                </>
                            )}
    
                            { !video ? null : (
                                <CartButton
                                    click = { this.props.playHandler }
                                >
                                    <Icon.Play/>
                                </CartButton>
                            ) }
                        </div>

                        <CartButton
                            click = { this.props.closeHandler }
                        >
                            <Icon.ToBack/>
                        </CartButton>
                    </div>
                </div>
            </div>
        );
    }
}

export default Cart;
